import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
} from 'react-bootstrap/lib';

function CodeTextArea({ label, value }) {
  let textarea = null;
  return (
    <FormGroup>
      <ControlLabel>{label}</ControlLabel>
      <div className="widget-code-block">
        <FormControl
          rows={3}
          componentClass="textarea"
          value={value}
          onChange={() => {}}
          inputRef={ref => {
            textarea = ref;
          }}
        />
        <Button
          onClick={() => {
            if (textarea) {
              textarea.select();
              document.execCommand('copy');
            }
          }}
        >
          Copy to Clipboard
        </Button>
      </div>
    </FormGroup>
  );
}

CodeTextArea.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
};

export default CodeTextArea;
